var _g, _path, _g2, _g3, _g4, _g5, _g6, _g7, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 83,
    viewBox: "0 0 58 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Flag"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graphic Elements"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kenya"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect10644",
    d: "M18.0382 2.51009C29.0203 13.9954 44.3578 8.00114 55.34 19.4864L48.7407 45.9705C37.7586 34.4852 22.4211 40.4795 11.439 28.9942L18.0382 2.51009Z",
    fill: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect10646",
    d: "M18.9631 2.41885C29.6759 13.2811 44.6375 7.61204 55.3503 18.4743L53.4283 25.9525C42.7155 15.0903 27.754 20.7594 17.0412 9.8971L18.9631 2.41885Z",
    fill: "#434A54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect10648",
    d: "M16.1663 12.4274C26.8806 23.2948 41.8443 17.6231 52.5586 28.4905L50.6137 36.0603C39.8994 25.1929 24.9358 30.8647 14.2215 19.9972L16.1663 12.4274Z",
    fill: "#ED5565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect10650",
    d: "M13.3503 22.536C24.0631 33.3982 39.0246 27.7292 49.7374 38.5914L47.8158 46.0683C37.103 35.2061 22.1415 40.8752 11.4287 30.013L13.3503 22.536Z",
    fill: "#57A863"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g10675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "spear"
  }, /*#__PURE__*/React.createElement("path", {
    id: "use10654",
    d: "M26.0498 31.7934C26.1343 31.8766 26.2187 31.9592 26.3031 32.0412C30.1393 28.0235 34.0166 23.841 37.8669 19.7671C38.369 19.7463 38.7391 19.3579 39.1096 18.9666C39.3555 18.7054 40.3428 17.6714 41.0287 16.1871C39.5829 16.9269 38.5937 17.9799 38.3455 18.2389C37.9748 18.6312 37.6038 19.0246 37.6114 19.5268C33.7596 23.6084 29.8829 27.7884 26.0498 31.7934Z",
    fill: "#F5F7FA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "use10657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "spear_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "use10654_2",
    d: "M36.3669 34.0369L36.0308 34.1344C34.5415 28.8376 33.0121 23.7054 31.5088 18.465C31.0746 18.233 30.9306 17.7259 30.7866 17.2185C30.4732 16.1181 30.3414 14.9917 30.3981 13.8984C31.3148 15.2297 31.7008 16.571 31.7981 16.9096C31.9426 17.4146 32.0879 17.9184 31.8465 18.3598C33.3517 23.5924 34.8801 28.7288 36.3669 34.0369Z",
    fill: "#F5F7FA"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path10659",
    d: "M28.9985 27.7309C29.1706 29.252 30.2212 32.4237 31.2763 32.6392C32.3314 32.8546 34.7899 30.4278 35.6659 29.1503L37.7777 20.753C37.6057 19.2315 36.5547 16.06 35.5 15.8444C34.4453 15.6287 31.9863 18.0557 31.1104 19.3333L28.9985 27.7309Z",
    fill: "#ED5565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "deco r",
    d: "M35.3458 28.9222C36.2561 27.6228 36.9851 26.2887 37.3505 24.8702C37.7159 23.4516 37.7193 21.9487 37.5399 20.4107C36.6293 21.71 35.8997 23.0524 35.5343 24.4709C35.1689 25.8895 35.1662 27.3841 35.3458 28.9222Z",
    fill: "#434A54"
  }), /*#__PURE__*/React.createElement("g", {
    id: "use10662"
  }, /*#__PURE__*/React.createElement("path", {
    id: "deco r_2",
    d: "M29.2267 28.0879C29.0577 26.5534 29.0699 25.0501 29.4393 23.6287C29.8087 22.2074 30.5358 20.8659 31.4435 19.5584C31.6122 21.0943 31.6025 22.5881 31.233 24.0099C30.8635 25.4316 30.1344 26.7805 29.2267 28.0879Z",
    fill: "#434A54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g10673"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ellipse10664",
    d: "M33.6523 23.201C34.0254 23.2731 34.2091 23.7989 34.0625 24.3751C33.916 24.9512 33.4953 25.3594 33.1215 25.287C32.7478 25.2146 32.5656 24.6894 32.7122 24.1133C32.8588 23.5372 33.2798 23.1276 33.6523 23.201Z",
    fill: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "deco br",
    d: "M33.1588 25.3203C33.1588 25.3203 33.5097 26.8892 32.8836 29.2209C32.2576 31.5525 31.1371 32.8504 31.1371 32.8504L33.1588 25.3203Z",
    fill: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "use10667"
  }, /*#__PURE__*/React.createElement("path", {
    id: "deco br_2",
    d: "M33.6061 23.173C33.6061 23.173 33.2623 21.606 33.8899 19.2741C34.5175 16.9423 35.6331 15.6413 35.6331 15.6413L33.6061 23.173Z",
    fill: "#F5F7FA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "use10669"
  }, /*#__PURE__*/React.createElement("path", {
    id: "deco br_3",
    d: "M32.9293 25.3209C32.9293 25.3209 31.8132 26.6237 31.1857 28.9556C30.5581 31.2875 30.9019 32.8545 30.9019 32.8541L32.9293 25.3209Z",
    fill: "#F5F7FA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "use10671"
  }, /*#__PURE__*/React.createElement("path", {
    id: "deco br_4",
    d: "M33.8439 23.166C33.8439 23.166 34.9603 21.8633 35.5877 19.5318C36.2152 17.2003 35.8712 15.6328 35.8712 15.6328L33.8439 23.166Z",
    fill: "#F5F7FA"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.53341 65.9585C2.56037 65.8566 2.35145 65.6737 2.06679 65.55C1.78212 65.4263 1.5295 65.4087 1.50254 65.5107C1.47559 65.6127 1.6845 65.7956 1.96917 65.9192C2.25384 66.0429 2.50646 66.0605 2.53341 65.9585Z",
    fill: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3236_11481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 19,
    height: 64
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "clipPath"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.53578 65.9356C2.544 65.9061 2.53303 65.8676 2.50013 65.8226L20.1448 2.91374C20.1777 2.95872 20.1888 2.9967 20.1804 3.02675L2.53578 65.9356Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3236_11481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.53615 65.9356L20.1808 3.02675C20.1892 2.9967 20.1781 2.95872 20.1452 2.91374L2.50049 65.8226C2.5334 65.8676 2.54437 65.9061 2.53615 65.9356Z",
    fill: "#787878"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3236_11481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 20,
    height: 64
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "clipPath-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.0125 2.61307C19.033 2.53913 19.1739 2.51765 19.3914 2.569C19.6962 2.63999 20.0371 2.82607 20.1523 2.98471L2.65038 65.8316C2.53512 65.673 2.19197 65.4859 1.88949 65.4159C1.67185 65.3651 1.53105 65.386 1.51043 65.4605L19.0125 2.61307Z",
    fill: "white"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3236_11481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M2.51239 65.8336L20.1523 2.92712C20.1287 2.89607 20.1024 2.86816 20.074 2.84383L2.43362 65.7501C2.4621 65.7744 2.48835 65.8023 2.51194 65.8334",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.43965 65.755L20.0866 2.84598C20.074 2.83466 20.0603 2.82353 20.0451 2.8124L2.39868 65.7216C2.41249 65.7321 2.42615 65.7433 2.44011 65.7551",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M2.40629 65.7303L20.053 2.82349L20.0182 2.79696L2.3703 65.7064L2.40552 65.7331",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M2.37457 65.7076L20.0256 2.79597L19.9928 2.77334L2.34483 65.6831L2.37717 65.7056",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M2.34882 65.6802L19.997 2.77031L19.9651 2.7499L2.31692 65.6598L2.34882 65.6802Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M2.32014 65.6638L19.9683 2.75394L19.9372 2.73446L2.28854 65.6441L2.32014 65.6638Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M2.29448 65.6469L19.9431 2.7372L19.9112 2.71865L2.26303 65.6285L2.29402 65.6467",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M2.26686 65.6304L19.9147 2.72028L19.8829 2.70302L2.23465 65.6129L2.26641 65.6302",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M2.24028 65.6146L19.8885 2.70465L19.8568 2.6874L2.20837 65.5979L2.24028 65.6146Z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M2.21329 65.5957L19.8616 2.68532L19.8283 2.67177L2.18015 65.5816L2.21251 65.5985",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M2.1854 65.5875L19.8335 2.67769L19.8002 2.66415L2.15226 65.5716L2.18557 65.5851",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M2.15656 65.5718L19.8048 2.66188L19.7715 2.64834L2.12326 65.5582L2.15656 65.5718Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M2.13111 65.558L19.7797 2.64644L19.7464 2.6329L2.09781 65.5426L2.13157 65.5563",
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M2.1006 65.5412L19.7493 2.631L19.7151 2.61709L2.06699 65.5269L2.10075 65.5406",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M2.07253 65.5344L19.7204 2.62412L19.6853 2.60983L2.03588 65.5201L2.071 65.5344",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M2.04116 65.519L19.6905 2.60886L19.653 2.59365L2.00543 65.5033L2.04284 65.5185",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M2.01253 65.508L19.6596 2.59658L19.6132 2.58081L1.96676 65.49L2.01237 65.5085",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M1.99527 65.4972L19.6167 2.59841C19.5703 2.5832 19.5233 2.56966 19.4798 2.56001C19.4461 2.55185 19.4143 2.54573 19.3838 2.54072L1.76309 65.4405C1.79309 65.4444 1.82516 65.4507 1.8593 65.4592C1.90686 65.4705 1.95016 65.4826 1.99618 65.4976",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M1.77128 65.4564L19.4159 2.54745C19.3939 2.54467 19.3729 2.5417 19.3534 2.54059L1.70749 65.4484C1.72683 65.4501 1.74799 65.4525 1.76991 65.4558",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M1.71451 65.4479L19.363 2.53948C19.3476 2.53818 19.3332 2.53725 19.3195 2.53725L1.67216 65.4468C1.68588 65.4468 1.70035 65.4477 1.71573 65.449",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M1.67617 65.4453L19.3249 2.53521L19.2923 2.53558L1.64355 65.4457L1.67617 65.4453Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M1.64648 65.4512L19.296 2.5408L19.2691 2.54284L1.61949 65.4533L1.64648 65.4512Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M1.62235 65.4575L19.2726 2.54675L19.2501 2.55065L1.59993 65.4613L1.62235 65.4575Z",
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M1.6029 65.4645L19.2534 2.55364L19.2336 2.55735L1.58291 65.4687C1.58947 65.4671 1.59604 65.4654 1.6029 65.4645Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M1.58469 65.4639L19.2358 2.55234L19.2191 2.5579L1.5679 65.4695C1.57337 65.4671 1.57898 65.4652 1.58469 65.4639Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M1.56814 65.4711L19.2192 2.55923L19.2042 2.56553L1.55317 65.4774C1.55799 65.4748 1.563 65.4727 1.56814 65.4711Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M1.55684 65.4783L19.2085 2.56648L19.1952 2.57409L1.5437 65.4853C1.54794 65.4826 1.55233 65.4802 1.55684 65.4783Z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M1.54462 65.4847L19.1965 2.57337C19.1927 2.57567 19.1891 2.57833 19.1856 2.58134L1.53376 65.4927L1.54462 65.4847Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M1.53318 65.4921L19.1852 2.58062C19.1818 2.58351 19.1787 2.5868 19.1759 2.59045L1.52337 65.5017L1.53318 65.4921Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M1.52451 65.5073L19.1771 2.59606C19.1742 2.59921 19.1717 2.60276 19.1695 2.60663L1.51562 65.5174C1.5178 65.5136 1.52016 65.51 1.52268 65.5066",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M1.5165 65.5133L19.171 2.60234C19.1693 2.6066 19.168 2.61108 19.1673 2.61569L1.51278 65.5267C1.51357 65.522 1.51482 65.5176 1.5165 65.5133Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M1.51074 65.5289L19.1637 2.61709L1.51012 65.5311",
    fill: "#858585"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3236_11481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 20,
    height: 65
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "clipPath-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M1.51345 65.453L19.0076 2.60925C18.9993 2.63926 19.0104 2.67725 19.0431 2.72284C19.1586 2.88093 19.5017 3.06797 19.8039 3.13863C20.0215 3.18945 20.1625 3.16798 20.1829 3.09405L2.68894 65.9373C2.66848 66.0112 2.52756 66.0327 2.30995 65.9819C2.00526 65.9108 1.66457 65.7242 1.54916 65.5661C1.51644 65.5205 1.5053 65.4825 1.51345 65.453Z",
    fill: "white"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3236_11481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M1.5142 65.5128L19.1458 2.60928C19.1374 2.63933 19.1486 2.67735 19.1816 2.72299C19.2055 2.75365 19.2318 2.78153 19.2599 2.80629L1.6285 65.7092C1.60014 65.6848 1.5739 65.6569 1.55019 65.6259C1.51722 65.5803 1.50598 65.5423 1.5142 65.5128Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M1.60777 65.6992L19.2545 2.78897L19.296 2.82256L1.64952 65.7317L1.60808 65.6981",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M1.64067 65.7298L19.2882 2.82022L19.3231 2.8462L1.67559 65.7558L1.64067 65.7298Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M1.6708 65.7612L19.3187 2.85147L19.3515 2.87411L1.70361 65.7839L1.6708 65.7612Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M1.69923 65.777L19.347 2.86691L19.3787 2.88788L1.73036 65.8001L1.69861 65.7792",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M1.72418 65.8026L19.3731 2.89054L19.4044 2.90946L1.7561 65.8193L1.7248 65.8004",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M1.75312 65.816L19.4014 2.90616L19.4328 2.92453L1.78458 65.8344L1.75312 65.816Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M1.77941 65.8289L19.4269 2.92179L19.4585 2.9396L1.81025 65.8495L1.77863 65.8317",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M1.80429 65.849L19.453 2.93741L19.4849 2.95411L1.83668 65.864L1.80476 65.8473",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M1.83314 65.8629L19.4813 2.95304L19.5146 2.96658L1.86645 65.8764L1.83314 65.8629Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M1.86158 65.8785L19.5098 2.96866L19.5431 2.98221L1.89473 65.8945L1.86142 65.8809",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M1.89003 65.8941L19.5382 2.98429L19.5715 2.99783L1.92334 65.9077L1.89003 65.8941Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M1.91542 65.902L19.5636 2.9921L19.5969 3.00565L1.94873 65.9155L1.91542 65.902Z",
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M1.94387 65.9175L19.5919 3.00772L19.6261 3.02164L1.97809 65.9314L1.94387 65.9175Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M1.97476 65.9253L19.6227 3.01554L19.6578 3.02983L2.01142 65.9396L1.97491 65.9247",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M2.00548 65.9408L19.6531 3.03116L19.6905 3.04638L2.04289 65.956L2.00548 65.9408Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M2.03614 65.9509L19.6826 3.04176L19.729 3.05753L2.08255 65.9667L2.03614 65.9509Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M2.07838 65.956L19.6996 3.05728C19.7461 3.0725 19.7932 3.08549 19.8366 3.0957C19.8706 3.10337 19.9027 3.10962 19.9328 3.11445L2.31155 66.0132C2.28205 66.0086 2.24997 66.0023 2.21531 65.9944C2.17001 65.984 2.12442 65.971 2.07838 65.956Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M2.27802 66.011L19.9227 3.10254C19.9446 3.10588 19.9658 3.1083 19.9853 3.10942L2.34183 66.0189C2.32203 66.0171 2.30132 66.0149 2.27939 66.0115",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M2.33272 66.0103L19.9788 3.09976C19.9942 3.10106 20.0086 3.10199 20.0224 3.10199L2.37493 66.012L2.33135 66.0098",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M2.37053 66.016L20.0193 3.1059C20.0304 3.10609 20.0416 3.10628 20.0519 3.10554L2.40283 66.0167L2.37006 66.0177",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M2.39737 66.0079L20.0469 3.09754L20.0739 3.0955L2.42482 66.0042L2.39783 66.0063",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M2.42177 66.0077L20.072 3.09698L20.0943 3.09364L2.44404 66.0043C2.43668 66.006 2.42924 66.0071 2.42177 66.0077Z",
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M2.44135 66L20.0919 3.08917L20.1119 3.0849L2.46088 65.9955L2.44135 66Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M2.45792 66.0001L20.1093 3.08935C20.1154 3.0875 20.1209 3.08602 20.1261 3.08379L2.47518 65.9948C2.46998 65.997 2.46403 65.9983 2.45792 66.0001Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M2.47336 65.9902L20.124 3.08135L20.139 3.07505L2.48771 65.9862L2.47274 65.9925",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M2.48749 65.9926L20.139 3.08135L20.1522 3.07431L2.50063 65.9855L2.48749 65.9926Z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M2.49983 65.9776L20.1517 3.06629L20.1627 3.05775L2.51085 65.9691L2.49983 65.9776Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M2.50967 65.9705L20.1618 3.05903C20.1652 3.05625 20.1684 3.05295 20.1711 3.0492L2.51886 65.9612C2.51607 65.9647 2.51298 65.9678 2.50967 65.9705Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M2.51726 65.9632L20.171 3.05177C20.1739 3.04869 20.1764 3.04513 20.1785 3.0412L2.52676 65.9529C2.52456 65.9569 2.52198 65.9606 2.51909 65.964",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M2.52711 65.9485L20.18 3.03671C20.1817 3.03245 20.1829 3.02796 20.1837 3.02335L2.53084 65.9351C2.52982 65.9397 2.52857 65.9441 2.52711 65.9485Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M2.53092 65.9351L20.1839 3.02335L2.53138 65.9335",
    fill: "#858585"
  }))))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M20.1882 3.03665C20.2152 2.93469 20.0062 2.75178 19.7216 2.62811C19.4369 2.50444 19.1843 2.48685 19.1573 2.58881C19.1304 2.69078 19.3393 2.87369 19.624 2.99736C19.9086 3.12102 20.1612 3.13862 20.1882 3.03665Z",
    fill: "#A3A3A3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/Flag.b64caf52bff97cdd15b2fcd9bf1e3203.svg";
export { ForwardRef as ReactComponent };